@use '../../../assets/styles/utilities.scss';

:host {
  display: block;
}

.login-promo {
  background: linear-gradient(168.66deg, #342392 8.35%, #5762c0 63.87%, #5548a6 88.54%);
}
